

var BankService = function($http,
                           $q,
                           configManager,
                           AccountConfigManager,
                           userProfileManager,
                           BankInfoService,
                           BankDetailsFormatterFactory) {
    var accountConfigManager = AccountConfigManager.getConfig(configManager);
    var countryCode = accountConfigManager.site.countryCode;
    var account = userProfileManager.getUserProfileMasterInfo() ? userProfileManager.getUserProfileMasterInfo() : undefined;
    var accountId = account ? account.accountId : '';

    var isDistributorEligible = function(data) {
        if (nuskin.util.isAuthor()) {
            return true;
        }
        var atlasServiceUrl = accountConfigManager.system['atlas_service_url'];

        var jwtToken = userProfileManager.getJWT();
        var config = {
            headers: {
                'content-type': 'application/json',
                'showgloballoader': true
            }
        };

        var url = atlasServiceUrl + 'eligible/' + accountId + '.json?eid=' + jwtToken;

        return $http.get(url, config);
    };

    var formatPayload = function(data) {
        var accountId = userProfileManager.getUserProfileMasterInfo().accountId;
        var payload = {};
        var market = data.ibanMarketCode ? data.ibanMarketCode : countryCode;

        var formatter = BankDetailsFormatterFactory.getFormatter(market);
        formatter.setAcceptedDirectDepositPolicy(payload);
        formatter.setAccountHolder(payload, data);
        formatter.setAccountNumber(payload, data);
        formatter.setAccountType(payload, data);
        formatter.setAction(payload);
        formatter.setBank(payload, data);
        formatter.setControlKey(payload, data);
        formatter.setCountryCode(payload, market);
        formatter.setDistributor(payload, market, accountId);
        formatter.setIBAN(payload, data);
        formatter.setRoutingNumber(payload, data);
        formatter.setSystemId(payload);
        formatter.setUserId(payload, accountId);

        return payload;
    };

    var saveBankDetails = function(data) {
        return BankInfoService($http, $q, configManager, AccountConfigManager).writeBankInfoToAccount(data);
    };

    return {
        'isDistributorEligible': isDistributorEligible,
        'formatPayload': formatPayload,
        'saveBankDetails': saveBankDetails

    };
};

export default BankService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/bank-service.js
// module id = 26
// module chunks = 0